import { checkInterfaceKeys } from './utils';
import { FileValidation, FocusFile } from '../types';
import { useTranslations } from 'i18n';

export const useFocusFileValidator = () => {
    const { __ } = useTranslations();
    // todo additional validation as discovered
    return (data: object): FileValidation => {
        const isValid = checkInterfaceKeys<FocusFile>(data, ['session', 'tags', 'timing']); // todo get keys dynamically if possible
        const reason = isValid ? '' : __('smt_importer.validate_fail', { productName: 'Focus' });

        return {
            isValid,
            validationResultDescription: reason,
        };
    };
};
